import React, { useContext } from "react";
import "../App.css";
import { State } from "../context/State";

const Link = ({
  onClick,
  children,
  // onMouseOver,
  // onMouseOut,
  hoverDesc = "",
  isActive = true,
  style = {}
}) => {
  const { setDescription } = useContext(State);
  return (
    <button
      disabled={!isActive}
      style={!isActive ? { color: "gray", ...style } : style}
      className="link-button"
      onMouseEnter={
        hoverDesc ? () => setDescription(hoverDesc || "") : undefined
      }
      onMouseOut={hoverDesc ? () => setDescription("") : undefined}
      // onMouseEnter={onMouseOver}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Link;
